import { useAppSelector } from "../../../store/hooks";
import { useGetAotdByNumberQuery } from "../printsApi";
import { FORMATS } from "../printProducts";
import type { FormatInfo, PrintFormat } from "../printProducts";

// Today's AOTD for its prints: the latest finished day. Waits for the session restore so the
// request carries the token (isAuthor is only true on a signed-in request, and the answer stays
// cached).

export const BIG_FIRST: PrintFormat[] = ["poster", "wall-card", "trading-card"];
export const FORMATS_BIG_FIRST: FormatInfo[] = BIG_FIRST.map((f) => FORMATS.find((info) => info.format === f)!);
/** No poster-size original: digital foil can't take a 50 cm sheet. */
export const ORIGINAL_FORMATS: FormatInfo[] = FORMATS_BIG_FIRST.filter((info) => info.variantIds.original);

export function useToday() {
  const authReady = useAppSelector((s) => s.auth.bootstrapStatus === "ready");
  return useGetAotdByNumberQuery("latest", { skip: !authReady });
}
